export type AverageComparison = "about" | "above" | "below";

// Within ±10% of the average reads as "about average" rather than a win or a miss.
const ABOUT_AVERAGE_MARGIN = 0.1;

export function compareToAverage(
  views: null | number,
  averageViews: null | number,
): AverageComparison | null {
  if (!averageViews || views === null) return null;

  const difference = (views - averageViews) / averageViews;

  if (difference > ABOUT_AVERAGE_MARGIN) return "above";
  if (difference < -ABOUT_AVERAGE_MARGIN) return "below";

  return "about";
}
